module.exports = __webpack_public_path__ + "assets/img/recipe-img.6aa95fe6.jpg";